module.exports = __webpack_public_path__ + "static/media/money-emoji-svgrepo-com.b1b8f6bc.svg";